import { Component } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Subscription } from 'rxjs';
import { BlockTemplateComponent } from './@tema/components/block-iu-template/block-iu-template.component';

import { NotificacionesService } from './services/notificaciones.service';
import { RepseService } from './services/repse.service';
import { ThemeService } from './services/theme/theme.service';
import { Title } from '@angular/platform-browser';
import { FaviconService } from './services/theme/favicon.service';

@Component({
  selector: 'app-root',
  template: `
  <div [ngClass]="theme | async">
    <block-ui [delayStart]="0" [delayStop]="0" [template]="blockTemplate">
      <router-outlet ></router-outlet>
    </block-ui>
  </div>
    `,
  styles: []
})
export class AppComponent {
  title = 'ies-web';
  @BlockUI() blockUI: NgBlockUI;
  blockTemplate = BlockTemplateComponent;
  setBlockui = false;
  loaderSubs = new Subscription();
  theme;


  constructor(
    private notificacionesService: NotificacionesService,
    private repse: RepseService,
    private themeService: ThemeService,
    private titleService: Title,
    private faviconService: FaviconService

  ) {
    this.initTheme();
    this.theme = this.themeService.currentTheme;
    console.log(1, new Date());
    sessionStorage.removeItem('IES-IN');
    this.loaderSubs = notificacionesService.loader$.subscribe(estatus => {
      if (estatus === null || estatus === undefined) return
      estatus === 'Activar' ? this.blockUI.start('Espere por favor...') : this.blockUI.stop();
    });


  }


  initTheme() {
    //para desarrollo esta harcodeado
    //let compania = 'banorte';
    //let compania = 'afirme';
    //let compania = 'latino';
    let compania = 'ies';
    //let compania = 'gs';
    this.themeSelect(compania);

  }

  private themeSelect(nombre: string) {
    if (nombre === 'banorte') {
      this.themeService.changeTheme('theme-banorte');
      this.titleService.setTitle("REPSE");
      this.faviconService.setFavicon("./assets/img/banorte-favicon.ico");
    }
    if (nombre === 'afirme') {
      this.themeService.changeTheme('theme-afirme');
      this.titleService.setTitle("REPSE");
      this.faviconService.setFavicon("./assets/img/afirme-favicon.ico");
    }
    if (nombre === 'latino') {
      this.themeService.changeTheme('theme-latino');
      this.titleService.setTitle("REPSE");
      this.faviconService.setFavicon("./assets/img/latino.ico");
    }
    if (nombre === 'ies') {
      this.themeService.changeTheme('theme-ies');
      this.titleService.setTitle("REPSE");
      this.faviconService.setFavicon("./assets/img/ies.png");
    }
    if (nombre === 'gs') {
      this.themeService.changeTheme('theme-gs');
      this.titleService.setTitle("GS REPSE");
      this.faviconService.setFavicon("./assets/img/ies.png");
    }

  }


}
